import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';

const navSlice = createSlice({
  name: 'nav',
  initialState,
  reducers: {
    updateActivePrimary(state, action) {
      return {
        ...state,
        primary: {
          ...state.primary,
          position: {
            left: action.payload.left,
            width: action.payload.width
          },
          context: action.payload.context
        }
      };
    },
    updateActiveSecondary(state, action) {
      return {
        ...state,
        secondary: {
          ...state.secondary,
          position: {
            left: action.payload.left,
            width: action.payload.width
          },
          context: action.payload.context
        }
      };
    }
  }
});

export default navSlice;
